import { RemoveCircle } from '@material-ui/icons'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const StatusPending = () => (
  <ThemeProvider theme={theme}>
    <StatusPendingDiv />
  </ThemeProvider>
)

const StatusPendingDiv = styled(RemoveCircle)`
  && {
    font-size: 16px;
    margin: 0 2px;
    color: ${props => props.theme.colors.orange};
  }
`

export default StatusPending
